import axios from 'axios'

export function findPeopleInput(data) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/reviewer',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function reviewerApply(data) {
    return axios({
        method: 'post',
        url: '/user/smartEnterSchoolApply/people/reviewer',
        data: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findImg(id) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/img',
        params: {id: id},
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function exportApply(data) {
    return axios({
        method: 'post',
        url: '/user/smartEnterSchoolApply/exportCheck',
        data: data,
        responseType: 'blob',
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}